import * as React from 'react';
import moment from 'moment';
import { debounce } from 'lodash';

import CalendarText from '../../contexts/calendar-text';
import LazyImage from '../lazy-image';
import { isExternalUrl } from '../../helpers/is-external-url';
import { getHeightOfHidden } from '../../helpers/get-height-of-hidden';

import ListEventTagsView from './event-tags.view';
import { IEvent, IProduction } from '../../interfaces';
import ListEventView from './event.view';
import { CalendarAppText } from '../../redux-state/interfaces/calendar-app-text.state';

export interface IListProductionViewProps {
    production: IProduction<IEvent>;
    openProdList: boolean;
    selectedFromMiniCalendar: boolean;
    dateSelectedFromMiniCalendar: moment.Moment;
}

export interface IListProductionViewState {
    ticketPanelOpen: boolean;
    resizeListener: EventListener;
    panelRef: React.RefObject<HTMLDivElement>;
    openTogglepanelRef: React.RefObject<HTMLDivElement>;
    openTogglepanelHeight: number;
    panelHeight: number;
    initialPanelHeight: number;
    lastPerformanceLoadedIndex: number;
    loadMorePerformances: boolean;
    morePerformancesPanelRef: React.RefObject<HTMLDivElement>;
    morePerformancesPanelHeight: number;
}

/**
 * The view for an individual calendar event.
 */
class ListProductionView extends React.Component<IListProductionViewProps, IListProductionViewState> {
    constructor(props: IListProductionViewProps) {
        super(props);

        this.state = {
            ticketPanelOpen: false,
            panelHeight: null,
            openTogglepanelHeight: null,
            initialPanelHeight: null,
            panelRef: React.createRef<HTMLDivElement>(),
            openTogglepanelRef: React.createRef<HTMLDivElement>(),
            morePerformancesPanelRef: React.createRef<HTMLDivElement>(),
            resizeListener: debounce(() => {
                this.setState({
                    panelHeight: getHeightOfHidden(this.state.panelRef.current),
                    openTogglepanelHeight: getHeightOfHidden(this.state.openTogglepanelRef.current),
                    initialPanelHeight: getHeightOfHidden(this.state.panelRef.current),
                    morePerformancesPanelHeight: getHeightOfHidden(this.state.morePerformancesPanelRef.current)
                });
            }, 50),
            lastPerformanceLoadedIndex: 8,
            loadMorePerformances: false,
            morePerformancesPanelHeight: null
        }
    }

    loadMore = () => {
        this.setState({
            loadMorePerformances: !this.state.loadMorePerformances,
            lastPerformanceLoadedIndex: this.state.lastPerformanceLoadedIndex,
            panelHeight: (!this.state.loadMorePerformances ? getHeightOfHidden(this.state.panelRef.current) + getHeightOfHidden(this.state.morePerformancesPanelRef.current) : this.state.initialPanelHeight)
        });
    }

    componentDidMount() {
        if (this.props.production.events.length > 1) {
            this.setState({
                panelHeight: getHeightOfHidden(this.state.panelRef.current),
                initialPanelHeight: getHeightOfHidden(this.state.panelRef.current),
                morePerformancesPanelHeight: getHeightOfHidden(this.state.morePerformancesPanelRef.current)
            });
            window.addEventListener('resize', this.state.resizeListener);
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.dateSelectedFromMiniCalendar != prevProps.dateSelectedFromMiniCalendar && this.props.production.events.length > 1 && this.state.openTogglepanelRef.current != null) {
            this.setState({
                openTogglepanelHeight: getHeightOfHidden(this.state.openTogglepanelRef.current)
            });
        }
    }

    componentWillReceiveProps(nextProps, props) {
        if (nextProps.openProdList && !props.openProdList) {
            this.setState({ ticketPanelOpen: true });
        }
    }

    componentWillUnmount() {
        if (this.props.production.events.length > 1) {
            window.removeEventListener('resize', this.state.resizeListener)
        }
    }

    filterPerformanceByDateSelectionPrevProps(events: IEvent[], prevDateSelection: moment.Moment): IEvent[] {
        return events.filter(li => moment(li.eventDate).isSame(prevDateSelection, 'day'));
    }
    filterPerformanceByDateSelection(events: IEvent[]): IEvent[] {
        if (this.props.dateSelectedFromMiniCalendar != null && this.props.selectedFromMiniCalendar) {
            return events.filter(li => moment(li.eventDate).isSame(this.props.dateSelectedFromMiniCalendar, 'day'));
        }
        return events;
    }


    render(): React.ReactNode {
        if (this.props.production.events.length == 0)
            return null;

        if (this.props.dateSelectedFromMiniCalendar != null && this.props.selectedFromMiniCalendar && this.props.production.events.filter(li => moment(li.eventDate).isSame(this.props.dateSelectedFromMiniCalendar, 'day')).length == 0) {
            return null;
        }


        let openToggleState = this.props.dateSelectedFromMiniCalendar != null && this.props.selectedFromMiniCalendar;

        const isSinglePerformance = this.props.production.events.length == 1;

        const dateMoment = moment(this.props.production.events[0].eventDate);
        const dateX = dateMoment.startOf('day').format("X");


        return (
            <CalendarText.Consumer>
                {text => (
                    <li className="production-card-card">
                        <div className="production-card">
                            <div className="production-card-item">
                                {!isSinglePerformance ?
                                    <div className="production-card-date">

                                        <p className="h4-style">
                                            {this.props.production.firstPerformanceDate}
                                        </p>
                                        <span className="production-card-date-decorator"> </span>
                                        <p className="h4-style">
                                            {this.props.production.lastPerformanceDate}
                                        </p>
                                    </div>
                                    :
                                    <div className="production-card-date">
                                     <p className="h3-style"> {this.props.production.events[0].eventDateString}</p>
                                    </div>
                                 }

                            <div className="production-card-image">

                                    <a href={this.props.production.viewDetailCtaUrl}>
                                        <div className="production-card-image-container">
                                           {/* TODO: Create Alt Text Property*/}
                                            <img src={this.props.production.thumbnail} alt={this.props.production.name} />
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div className="production-card-item">
                            <div className="stack flex-column-between">
                                <div className="flex-between production-card-content">
                                    <div className="production-card-details">

                                        <p className="label">
                                            {this.props.production.conductor}
                                        </p>

                                            <a className="production-card-event-name" href={this.props.production.viewDetailCtaUrl} target={isExternalUrl(this.props.production.viewDetailCtaUrl) ? "_blank" : null}>
                                            <h3 className="ace-cal-list-event-name "
                                                id={isSinglePerformance ? `List-Day-${dateX}` : null}>
                                                {
                                                    <span dangerouslySetInnerHTML={{ __html: this.props.production.name }} />
                                                }
                                            </h3>
                                        </a>
                                        <p className="production-card-details-description">
                                            {this.props.production.synopsis}
                                        </p>
                                    </div>
                                    <p className="production-card-price">
                                        {this.props.production.priceInfo}
                                    </p>
                                </div>
                                <div className="production-card-ctas">
                                    {
                                        isSinglePerformance ?
                                            this.singlePerformanceCta() :
                                            this.multiPerformanceList(text)
                                    }
                                </div>
                            </div>






                        </div>
                        {
                            isSinglePerformance ? null :
                                <div className="production-card-panel panel-container">
                                    {
                                        openToggleState ?
                                            this.defaultToggleOpenList(text)
                                            :
                                            this.performanceToggle(text)
                                    }
                                </div>
                        }
                        </div>
                    </li>
        )
    }
            </CalendarText.Consumer>
        );
    }
    private defaultToggleOpenList(text: CalendarAppText) {
    return <div className="reveal-panel" aria-hidden={false} id={`Tickets_${this.props.production.id}`} ref={this.state.openTogglepanelRef} style={{ height: `${this.state.openTogglepanelHeight}px` }}>
        <div>
            <ul className="ace-date-rows">
                {
                    this.filterPerformanceByDateSelection(this.props.production.events).slice(0, this.state.lastPerformanceLoadedIndex).map(event => <ListEventView key={event.id} event={event} allowTabbing={this.state.ticketPanelOpen} />)}
            </ul>
        </div>
    </div>;
}
    private performanceToggle(text: CalendarAppText) {
    return <div className="reveal-panel" aria-hidden={!this.state.ticketPanelOpen} id={`Tickets_${this.props.production.id}`} ref={this.state.panelRef} style={{ height: `${this.state.panelHeight}px` }}>
        <div>
            <ul className="ace-date-rows">
                {this.props.production.events.slice(0, this.state.lastPerformanceLoadedIndex).map(event => <ListEventView key={event.id} event={event} allowTabbing={this.state.ticketPanelOpen} />)}
            </ul>
            <div className="reveal-panel" style={{ height: `${this.state.morePerformancesPanelHeight}px` }} aria-hidden={!this.state.loadMorePerformances} ref={this.state.morePerformancesPanelRef}>
                <ul className="ace-date-rows">
                    {this.props.production.events.slice(this.state.lastPerformanceLoadedIndex, this.props.production.events.length).map(event => <ListEventView key={event.id} event={event} allowTabbing={this.state.ticketPanelOpen} />)}
                </ul>
            </div>
            {this.props.production.events.length > this.state.lastPerformanceLoadedIndex ?
                <button type="button" className="btn" onClick={this.loadMore}>
                    {this.state.loadMorePerformances ?
                        text.showLessDatesButtonText
                        : text.viewMoreDatesButtonText}
                </button> : null}
        </div>
    </div>;
}

singlePerformanceCta() {
    const event = this.props.production.events[0];
    const eventIsOnSale = ((event.currentMosOnSaleDate
        && event.currentMosOnSaleDate < new Date()
        && event.currentMosOnSaleEndDate > new Date()
        && event.soldOut === false)
        || event.onSale === true);
    const isVolunteer = this.props.production.events[0].volunteerPurchase;
    return (
        <div className="production-card-footer">
            {
                eventIsOnSale ?
                    <div className="production-card-footer-item">

                        <a href={event.buyTicketCtaUrl} className="btn-primary" target={isExternalUrl(event.buyTicketCtaUrl) ? "_blank" : null}>
                            {
                                isVolunteer ? event.volunteerbuyTicketCtaText : event.buyTicketCtaText
                            }

                        </a>
                    </div>
                    :
                    (event.buyTicketCtaText.trim() == "" ? null :
                        <div className="production-card-footer-item transparent theme-dark">
                            <p className="btn-outline">
                                {event.notOnSaleText}
                            </p>
                        </div>
                    )
            }
        </div>
    );
}


multiPerformanceList(text: CalendarAppText) {
    return (this.props.production.events.length > 0
        ? (
            <>
                <div className="production-card-footer">
                    <div className="production-card-footer-item">
                        <button type="button" className={this.state.ticketPanelOpen ? "btn-outline btn-dropdown" : "btn-primary btn-dropdown"} aria-expanded={this.state.ticketPanelOpen} onClick={this.toggleShowingTicketPanel}>
                            {this.state.ticketPanelOpen ? "Collapse" : "View Dates"}
                        </button>
                    </div>
                </div>

                {
                    this.props.production.events.length > 8 && this.props.production.viewDetailCtaUrl.length > 0 ?
                        <div className="production-card-footer">
                            <div className="production-card-footer-item theme-dark">
                                <a href={this.props.production.viewDetailCtaUrl} className="btn-outline">
                                    <span dangerouslySetInnerHTML={{ __html: text.viewMoreDatesButtonText }} />
                                </a>
                            </div>
                        </div>

                        : null
                }
            </>

        ) : <div className="ace-cal-list-day-empty" dangerouslySetInnerHTML={{ __html: text.emptyDayMessage }}
            aria-labelledby={this.props.production.name}></div>
    );
}

toggleShowingTicketPanel = () => {
    this.setState({
        ticketPanelOpen: !this.state.ticketPanelOpen,
        loadMorePerformances: false
    });
    if (this.state.ticketPanelOpen) {
        this.setState({
            loadMorePerformances: false,
            lastPerformanceLoadedIndex: 8
        });
    }
}
}

export default ListProductionView;
